import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { PaymentVariable } from '@app/_models/payments';


@Injectable({
    providedIn: 'root'
})
export class PaymentsService {

    constructor(private http: HttpClient) { }

    getPaymentVariable(reservationType:number,fieldCapacity: number): Observable<PaymentVariable> {
        const params = `?reservation_type=${reservationType}&field_capacity=${fieldCapacity}`
        const url = `${environment.apiUrl}/last-payment-variable/${params}`;
        return this.http.get<PaymentVariable>(url);
    }
}
